import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';

import { SharedUiImgComponent } from '@fantaz/presentation/shared/ui/img';
import { SharedDirectivesSrcErrorModule } from '@fantaz/shared/directives/src-error';
import { SharedPipesDateModule } from '@fantaz/shared/pipes/date';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { TournamentsUiCountdownModule } from '@fantaz/tournaments/ui/countdown';
import { TournamentsUiDialogVideoModule } from '@fantaz/tournaments/ui/dialog-video';
import { TournamentControlsModule } from '@fantaz/tournaments/ui/tournament-controls';

import { BannerComponent } from './banner.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatRippleModule,
    TournamentControlsModule,
    SharedDirectivesSrcErrorModule,
    SharedPipesDateModule,
    MaterialModule,
    TournamentsUiCountdownModule,
    TournamentsUiDialogVideoModule,
    SharedUiImgComponent,
  ],
  declarations: [BannerComponent],
  exports: [BannerComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class TournamentBannerModule {}
